import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isAuth: null,
    userDetails: null,
    fetchAuthFinish:null
};

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        logout(state, action) {
            state.user = action.payload.user;
            state.isAuth = action.payload.isAuth;
        },
        init(state, action) {
            state.isAuth = action.payload.isAuth;
            state.user = action.payload.claims ? Object.assign({}, ...action.payload.claims.map(x => { return { [x.type]: x.value } })) : null;
            state.isAdmin = action.payload.user?.isAdmin;
            state.isStudent = state.user?.isstudent === 'Yes' ? true : null
            state.fetchAuthFinish=true;
        },
        setUserDetails(state, action) {
            state.userDetails = action.payload
        },
        updateUserClaims(state, action) {
            if (action.payload)
                state.user = { ...state.user, ...action.payload }
        },
    }
})

export const authActions = authSlice.actions;
export default authSlice
